<template>
  <div class="mini-trend-chart">
    <svg :width="width" :height="height" viewBox="0 0 320 70">
      <polyline
          :points="points"
          fill="none"
          :stroke="color"
          stroke-width="2"
      />
      <circle
          :cx="lastPointX"
          :cy="lastPointY"
          r="3"
          :fill="color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      validator: value => value.length > 1 // 至少需要2个数据点
    },
    color: {
      type: String,
      default: '#409EFF'
    },
    width: {
      type: Number,
      default: 320
    },
    height: {
      type: Number,
      default: 70
    }
  },
  computed: {
    normalizedData() {
      const min = Math.min(...this.data);
      const max = Math.max(...this.data);
      const range = max - min || 1; // 避免除以0

      // 上下各保留10px的padding
      return this.data.map(value => {
        return (value - min) / range * (this.height - 20) + 10;
      });
    },
    points() {
      const step = this.width / (this.normalizedData.length - 1);
      console.log('Normalized Data:', this.normalizedData, this.normalizedData.map((value, index) => {
        return `${index * step},${this.height - value}`;
      }).join(' '));
      return this.normalizedData.map((value, index) => {
        return `${index * step},${this.height - value}`;
      }).join(' ');
    },
    lastPointX() {
      const step = this.width / (this.normalizedData.length - 1);
      return (this.normalizedData.length - 1) * step;
    },
    lastPointY() {
      return this.height - this.normalizedData[this.normalizedData.length - 1];
    }
  }
};
</script>

<style scoped>
.mini-trend-chart {
  display: inline-block;
  width: 100%;
  max-width: 320px;
  overflow: visible;
}

.mini-trend-chart svg {
  display: block;
  overflow: visible;
}
</style>
